"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { useRef } from "react";
gsap.registerPlugin(Flip);
interface FlipTabItem {
  id: string;
  label: string;
}
interface AnimatedFlipTabsProps {
  items: FlipTabItem[];
  value: string;
  onChange: (id: string, index: number) => void;
  className?: string;
  mobileOnly?: boolean;
}
function AnimatedFlipTabs(t0) {
  const $ = _c(9);
  const {
    items,
    value,
    onChange,
    className,
    mobileOnly: t1
  } = t0;
  const mobileOnly = t1 === undefined ? true : t1;
  const containerRef = useRef(null);
  const pillRef = useRef(null);
  const flipState = useRef(null);
  let t2;
  if ($[0] !== mobileOnly) {
    t2 = () => {
      if (!flipState.current || !pillRef.current) {
        return;
      }
      const runFlip = () => {
        Flip.from(flipState.current, {
          duration: 0.25,
          ease: "circ.inOut",
          absolute: pillRef.current,
          targets: [pillRef.current, ".flip-tab-label"]
        });
      };
      if (mobileOnly) {
        const mm = gsap.matchMedia();
        mm.add("(max-width: 767px)", runFlip);
        return () => mm.revert();
      }
      runFlip();
    };
    $[0] = mobileOnly;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useGSAP(t2, {
    scope: containerRef,
    dependencies: [value, mobileOnly]
  });
  const handleSelect = function handleSelect(id, index) {
    if (!containerRef.current || id === value) {
      return;
    }
    flipState.current = Flip.getState(containerRef.current.querySelectorAll("[data-flip-id='flip-tab-pill'], .flip-tab-label"), {
      props: "color"
    });
    onChange(id, index);
  };
  const t3 = mobileOnly && "md:hidden";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn("w-fit border border-primary px-1 py-1 rounded-lg flex items-center justify-center gap-2", t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = items.map((item, index_0) => <div key={item.id} className="relative px-2 cursor-pointer">{value === item.id ? <div ref={pillRef} data-flip-id="flip-tab-pill" className="absolute inset-0 h-full bg-primary rounded-sm -z-10" /> : null}<span onClick={() => handleSelect(item.id, index_0)} className={cn("flip-tab-label z-10 text-xs md:text-sm truncate", value === item.id ? "text-primary-foreground" : "text-foreground")}>{item.label}</span></div>);
  let t6;
  if ($[5] !== containerRef || $[6] !== t4 || $[7] !== t5) {
    t6 = <div ref={containerRef} className={t4}>{t5}</div>;
    $[5] = containerRef;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
export { AnimatedFlipTabs, type FlipTabItem };